import React, { useState } from "react";
import { motion } from "framer-motion";
import { Ticket, AlertCircle, ArrowRight } from "lucide-react";
import { PillButton } from "./PillButton";
import { StickerCard } from "./StickerCard";
import { useApp } from "../../context/AppContext";
import { ASSETS } from "../../data/assets";

// Ticket-code entry gate. Calls onValid(ticket) on success.
export function TicketGate({ onValid, title = "Masukkan Kode Tiket", subtitle = "Validasi tiket kamu untuk mulai booking aktivitas.", defaultCode = "" }) {
  const { validateTicket } = useApp();
  const [code, setCode] = useState(defaultCode);
  const [contact, setContact] = useState("");
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    setError("");
    const res = validateTicket(code, contact || null);
    if (!res.ok) { setError(res.error); return; }
    onValid(res.ticket);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-4">
      <img src={ASSETS.trioHore} alt="" className="w-56 mx-auto mb-4 animate-float drop-shadow-xl" />
      <StickerCard className="p-6">
        <h1 className="font-display text-2xl text-sea-deep text-center flex items-center justify-center gap-2">
          <Ticket className="w-6 h-6 text-coral" /> {title}
        </h1>
        <p className="text-center text-sm font-semibold text-sea-deep/60 mt-1">{subtitle}</p>

        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <label className="text-sm font-bold text-sea-deep">Kode Tiket <span className="text-coral">*</span></label>
            <input
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="BLTR26-AB12CD"
              data-testid="gate-code-input"
              className="mt-1 w-full rounded-2xl border-2 border-slate-200 focus:border-sky-dark focus:ring-4 focus:ring-sky/40 outline-none px-4 py-3 font-display tracking-wider text-center text-lg text-sea-deep uppercase"
            />
          </div>
          <div>
            <label className="text-sm font-bold text-sea-deep">Email / No. WhatsApp <span className="text-sea-deep/40">(opsional)</span></label>
            <input
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              placeholder="Verifikasi tambahan"
              data-testid="gate-contact-input"
              className="mt-1 w-full rounded-2xl border-2 border-slate-200 focus:border-sky-dark focus:ring-4 focus:ring-sky/40 outline-none px-4 py-3 font-semibold text-sea-deep"
            />
          </div>

          {error && (
            <motion.div
              initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}
              className="flex items-start gap-2 bg-destructive/10 border-2 border-destructive/30 text-destructive rounded-2xl px-4 py-3 text-sm font-bold"
              data-testid="gate-error"
            >
              <AlertCircle className="w-5 h-5 shrink-0" /> {error}
            </motion.div>
          )}

          <PillButton type="submit" size="lg" className="w-full" data-testid="gate-submit">
            Validasi Tiket <ArrowRight className="w-5 h-5" />
          </PillButton>
        </form>
        <p className="mt-4 text-center text-xs font-semibold text-sea-deep/50">
          Coba kode contoh: <span className="text-coral font-bold">BLTR26-AB12CD</span>
        </p>
      </StickerCard>
    </div>
  );
}
